var _rect, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeveloperTools = function SvgDeveloperTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.78,
    y: 0.78,
    width: 22.44,
    height: 22.44,
    rx: 6,
    fill: "url(#developer-tools_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.698 10.136-4.835 5.186c-.411.441-.411 1.155 0 1.596l1.116 1.197c.41.44 1.077.44 1.487 0l4.836-5.186m-2.604-2.793.372-.399c.411-.44.411-1.155 0-1.595L9.954 6.945l.372-.399c1.233-1.322 3.231-1.322 4.464 0l3.347 3.59c.411.441.411 1.155 0 1.596l-1.116 1.197c-.41.44-1.077.44-1.488 0l-.371-.4a1.003 1.003 0 0 0-1.488 0l-.372.4m-2.604-2.793 2.604 2.793",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "developer-tools_svg__a",
    x1: 0.78,
    y1: 0.78,
    x2: 23.22,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3D34"
  })))));
};

export default SvgDeveloperTools;